import { useCallback, useEffect, useState } from "react";
import { GetCourseContent } from "../ajax";
import { Row, Col, message } from "antd";
import { BottomIfor } from "../bottom/bottominfo";
import { ButtonforPh } from "../bottom/buttomforph";
import { RenderHtml3 } from "../../components/renderhtml";
export function CoursePagePerspectiveDLC(props) {
  const [dlcdata, setDlcData] = useState({});
  const [totop, setTotop] = useState(false);

  function backtotop() {
    let oscroll = document.querySelector(".home-content");
    oscroll.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
  const request = useCallback(async () => {
    let res = await GetCourseContent();
    if (res.code !== 0) {
      message.error(res.message);
      return;
    } else {
      let json = res.result.filter((i) => i.id === props.active)[0];
      setDlcData(json);
    }
  }, [props.active]);


  useEffect(() => {
    let oscroll = document.querySelector(".home-content");
    oscroll.addEventListener("scroll", function (e) {
      if (e.target.scrollTop > 700) {
        setTotop(true);
      } else {
        setTotop(false);
      }
    });
  }, []);

  useEffect(() => {
    request();
  }, [request]);

  return (
    <div>
      <Row>
        <Col xs={0} sm={0} md={0} lg={24} xl={24}>
          <div className="coursePage-perspective-detail">
            <div
              style={totop ? { opacity: 1 } : { opacity: 0 }}
              className="backtotop"
              onClick={backtotop}
            ></div>
            <div className="coursepagedlc">
              <div className="course-perspective-introduction-detail1">
                <RenderHtml3
                  flow={780}
                  state={{ content: dlcdata && dlcdata.courseContent }}
                />
              </div>
              <div className="course-perspective-introduction-detail2">
                <div className="serise-box" style={{ padding: "20px 13px" }}>
                  <RenderHtml3
                    flow={"100%"}
                    state={{ content: dlcdata && dlcdata.description }}
                  />
                </div>
              </div>
            </div>
          </div>
          <BottomIfor />
        </Col>
        <Col xs={24} sm={24} md={24} lg={0} xl={0}>
          <div className="coursepagedlcph" style={{ minHeight: "600px" }}>
            <pre
              className="coursepagedlcph-tips"
              style={{
                wordWrap: "break-word",
                whiteSpace: "pre-wrap",
                overflow: "hidden",
                lineHeight: "1.5",
              }}
            >
              <div
                className="braft-output-content-ph"
                dangerouslySetInnerHTML={{
                  __html: dlcdata && parseStr(dlcdata.description),
                }}
              ></div>
            </pre>
            <pre
              className="coursepagedlcph-context"
              style={{
                wordWrap: "break-word",
                whiteSpace: "pre-wrap",
                overflow: "hidden",
                lineHeight: "1.5",
              }}
            >
              <div
                className="braft-output-content-ph"
                dangerouslySetInnerHTML={{
                  __html: dlcdata && parseStr(dlcdata.courseContent),
                }}
              ></div>
            </pre>
          </div>
          <ButtonforPh />
        </Col>
      </Row>
    </div>
  );
}
function parseStr(str = "") {
  return str?.replace(/font-size:.*?(?=px)/g, (value) => {
    let newValue = Math.ceil(parseInt(value.replace(/font-size:/g, "")) / 1.7);
    return `font-size:${newValue}`;
  });
}
